import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppButton } from "../../Generic/AppButton";
import CaregiverSurveyTrophyHeader from "../CaregiverSurveyTrophyHeader/CaregiverSurveyTrophyHeader";

interface Props {
  onClickStart: () => void;
  onClickNotInterested: () => void;
}

const CaregiverSurveyEntry = (props: Props) => {
  return (
    <div className="CaregiverSurveyEntry">
      <CaregiverSurveyTrophyHeader />
      <div className="surveyContent">
        <div className="surveyPrizeDetails">
          <p>{translate(STRINGS.TAKE_A_SURVEY)}</p>
          <span>{translate(STRINGS.HUNDRED_DOLLARS_GIFT_CARD)}</span>
        </div>
        <div className="actions">
          <AppButton color="primary" onClick={props.onClickStart}>
            {translate(STRINGS.START_A_SURVEY)}
          </AppButton>
          <span onClick={props.onClickNotInterested}>{translate(STRINGS.IM_NOT_INTERESTED)}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CaregiverSurveyEntry);
